import {
  NEW_PASSWORD_REQUEST,
  NEW_PASSWORD_SUCCESS,
  NEW_PASSWORD_FAILURE,
} from 'constants/ActionTypes';

const iState = {
  hasError: false,
  newPasswordError: null,
  newPasswordLoading: false,
};
export default function SettingsReducer(state = iState, action) {
  switch (action.type) {
    case NEW_PASSWORD_REQUEST:
      return {
        ...state,
        error: null,
        hasError: false,
        newPasswordLoading: true,
      };
    case NEW_PASSWORD_SUCCESS:
      return {
        ...state,
        newPasswordLoading: false,
      };
    case NEW_PASSWORD_FAILURE:
      return {
        ...state,
        newPasswordError: action.error,
        hasError: true,
        newPasswordLoading: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/SettingsReducer.js